/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_AwardService_Dtos_Release_ReleasePublishResponseDto } from '../models/Wealthlane_AwardService_Dtos_Release_ReleasePublishResponseDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class PublishReleaseService {

    /**
     * @param id
     * @param intendedShareRegistrationId
     * @param transactionAcquisitionTypeId
     * @returns Wealthlane_AwardService_Dtos_Release_ReleasePublishResponseDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppPublishReleasePublisRelease(
        id: string,
        intendedShareRegistrationId?: number,
        transactionAcquisitionTypeId?: number,
    ): CancelablePromise<Wealthlane_AwardService_Dtos_Release_ReleasePublishResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/publish-release/{id}/publis-release',
            path: {
                'id': id,
            },
            query: {
                'intendedShareRegistrationId': intendedShareRegistrationId,
                'transactionAcquisitionTypeId': transactionAcquisitionTypeId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
